module.exports = __webpack_public_path__ + "img/男鞋0.b1a4050b.png";